module.exports = __webpack_public_path__ + "img/网站-05.318fe45f.jpg";